<template>
  <div id="modelMissShare" class="modelMissShare">
    <div class="cheader-viewmodel">
      <div class="hpBanner-loge">
        <router-link class="hpBanner-pointer" :to="{ path: '/' }" tag="div"> </router-link>
        <embed class="hpBanner-img" :src="`${$baseUrl}dataMock/homePage/pkpmLogo.png`" />
        <h1 class="hpBanner-ctx">丨{{ '模型浏览' }}</h1>
      </div>
    </div>
    <div id="missShareMess" class="missShareMess">
      <span class="missShareTxt">资源分享已过期，请重新创建链接</span>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'modelCancelShare',
        components: {},
        data() {
            return {
                codeDialog: false,
            };
        },
        mounted() {},
        methods: {
            // returnShareFile() {},
            // closeWindow() {},
        },
    };
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~common/stylus/variable'
  #modelMissShare
    position absolute
    height 100%
    width 100%
    background-color #FFFAFA
    .cheader-viewmodel
      width 100%
      height 60px
      background-color $background-blue
      .hpBanner-loge
        z-index 99
        position:absolute
        left: 5.3%
        top: 12px
        display: flex
        align-items: center
        .hpBanner-pointer
          z-index 99
          cursor pointer
          background-color transparent
          position: absolute
          width: 120px
          height: 26px
        .hpBanner-img
          position: relative
          width: 120px
          height: 26px
        .hpBanner-ctx
          width: auto
          height: 36px
          color $font-white
          font-size: $font-size-logo
          font-weight: bold
          line-height: 36px
    .missShareMess
      text-align center
      padding-top 150px
      height 200px
      width 400px
      margin 50px auto
      .missShareTxt
        color #000000
        font-size 25px
    .dialog-footer
      height 50px
      width 400px
      margin 0px auto
    .btn
      width: 130px
      height: 40px
      margin-left 50px
      border-radius: 20px
      border: 0px
      outline: none
      &:hover
        color #ffffff
    .btn.share-btn
      background-color #0C78E2
    .btn.cancel-btn
      color: #303133
      border 1px solid #909399
</style>



// WEBPACK FOOTER //
// src/pages/ShareView/modelCancelShare.vue